import React, { useState } from 'react'
import Checkbox, { CheckboxClassKey } from '@mui/material/Checkbox'
import FormControlLabel, { FormControlLabelClassKey } from '@mui/material/FormControlLabel'

import './SelfSchedulingWebCodeLocation.sass'

const moduleName = 'self-scheduling-web-code-location'

type FormControlLabelClassOverrides = {
    readonly [key in FormControlLabelClassKey]?: string
}

type CheckboxClassOverrides = {
    readonly [key in CheckboxClassKey]?: string
}

const formControlLabelClassOverrides: FormControlLabelClassOverrides = {
    root: `${moduleName}__form-control-root`,
    label: `${moduleName}__form-control-label`,
}

const checkboxClassOverrides: CheckboxClassOverrides = {
    root: `${moduleName}__checkbox-root`,
}

export type Props = {
    allLocationsSelected: boolean
    selectAllLocations: (checked: boolean) => void
}

const SelfSchedulingWebCodeSelectAllLocations = ({ allLocationsSelected, selectAllLocations }: Props) => {
    const [loading, setLoading] = useState<boolean>(false)

    const handleOnChange = async () => {
        if (!allLocationsSelected) {
            setLoading(true)
            await selectAllLocations(true)
            setLoading(false)
        } else {
            await selectAllLocations(false)
        }
    }

    return (
        <div className={moduleName}>
            <div className={`${moduleName}__location-section`}>
                <FormControlLabel
                    classes={formControlLabelClassOverrides}
                    control={
                        <Checkbox
                            disabled={loading}
                            classes={checkboxClassOverrides}
                            checked={allLocationsSelected}
                            onChange={handleOnChange}
                            color="primary"
                        />
                    }
                    label={''}
                />

                <label className={`${moduleName}__label ${moduleName}__label--checkbox`}>
                    <div className={`${moduleName}__text ${moduleName}--text-bold`}>ALL PRACTICE LOCATIONS</div>
                </label>
            </div>
        </div>
    )
}

export default SelfSchedulingWebCodeSelectAllLocations
